import { create } from '@bufbuild/protobuf'
import { createPaginationFilters } from '@/features/admin/helper/createPaginationFilters'
import { BusinessSearchBy } from '@/generated/Enumerations/BusinessSearchBy_pb'
import { BusinessSortBy } from '@/generated/Enumerations/BusinessSortBy_pb'
import { DeletedItemSelection } from '@/generated/Enumerations/DeletedItemSelection_pb'
import { SearchType } from '@/generated/Enumerations/SearchType_pb'
import {
    BusinessFiltersDto_ColumnSearching,
    BusinessFiltersDto_ColumnSearchingSchema,
    BusinessFiltersDtoSchema,
} from '@/generated/Messages/Filters_pb'

const createBusinessSearching = (
    searchText: string
): BusinessFiltersDto_ColumnSearching[] => [
    create(BusinessFiltersDto_ColumnSearchingSchema, {
        searchBy: BusinessSearchBy.NAME,
        searchText,
        searchType: SearchType.CONTAINS,
    }),
    create(BusinessFiltersDto_ColumnSearchingSchema, {
        searchBy: BusinessSearchBy.DESCRIPTION,
        searchText,
        searchType: SearchType.CONTAINS,
    }),
]

export const businessQueryFilter = (
    deletedItemSelection: DeletedItemSelection,
    pageSize: number,
    page: number,
    sortByField: BusinessSortBy,
    sortDirectionDesc: boolean,
    searchText: string
) =>
    create(BusinessFiltersDtoSchema, {
        deletedItemSelection,
        pagination: createPaginationFilters(pageSize, page),
        sorting: [
            {
                sortBy: sortByField,
                descending: sortDirectionDesc,
            },
        ],
        searching: createBusinessSearching(searchText.toLowerCase()),
    })
